<template>
    <div>
        <v-container class="mx-0 mt-2 pa-0">
            <v-row no-gutters >
                <v-col cols="5">
                    <v-select dense outlined
                        :items="userRoles"
                        v-model="search.role"
                        item-value="id"
                        item-text="name"
                        label="Filtra per ruoli"
                        @input="custom_filter"
                        hide-details
                        clearable
                    ></v-select>
                </v-col>
                <v-col cols="5" class="pl-2">
                    <v-select dense outlined
                        :items="orgs"
                        v-model="search.org"
                        item-value="id"
                        item-text="value.name"
                        label="Filtra per ente"
                        @input="custom_filter"
                        hide-details
                        clearable
                    ></v-select>
                </v-col>
            </v-row>
        </v-container>
        <v-alert class="my-4" type="warning" v-if="errorMessage">Si è presentato un errore: {{ errorMessage }}</v-alert>
        <div v-if="loading" class="d-flex align-center justify-center flex-column my-8">
            <v-progress-circular 
                indeterminate
                size="100"
                width="20"
                color="primary"
                ></v-progress-circular>
        </div>
        <div v-else>
            <div class="d-flex justify-end mt-4 mb-2">             
                <v-btn :disabled="$store.state.offline" v-can="{obj_type:'user', action: 'edit'}" color="primary" @click="editUser(null, -1)"><v-icon class="pa-2" small>add_box</v-icon>Nuovo utente</v-btn>
            </div>
            <v-data-table
                :headers="headers"
                :items="filtered_users"
                class="elevation-1"
                hide-default-footer
                disable-pagination
            >
            <template v-slot:body="{ items }">
                <tbody>
                <tr v-for="(doc,idx) of items" :key="doc._id">
                    <td class="text-left">{{doc.name}}<br/><span v-if="orgs_dict[doc.org_id]" class="caption font-italic">({{ orgs_dict[doc.org_id].value.name }})</span></td>
                    <td class="text-left">{{doc.phone}}</td>
                    <td class="text-left">{{doc.username}}</td>
                    <td class="text-left">
                        <span v-for="(role, index) in doc.roles" :key="index">
                            <i>{{roles_dict[role].name}}</i><span v-if="index != doc.roles.length-1"><br/></span>
                        </span></td>
                    <td class="text-left">
                        <span>
                            <v-btn :disabled="$store.state.offline" fab small color="primary" v-can="{obj_type:'user', action: 'edit'}" @click.stop="changePassword(doc, idx)"><v-icon small>vpn_key</v-icon></v-btn>
                            <v-btn :disabled="$store.state.offline" fab small color="primary" v-can="{obj_type:'user', action: 'edit'}" @click.stop="editUser(doc, idx)"><v-icon small>create</v-icon></v-btn>
                            <v-btn :disabled="$store.state.offline || true" fab small color="primary" v-can="{obj_type:'user', action: 'remove'}" @click.stop="deleteUser(doc._id)"><v-icon small>delete</v-icon></v-btn>
                        </span>
                    </td>
                </tr>
                </tbody>
            </template>                
        </v-data-table>
        <div v-if="filtered_users.length > 0" class="text-center pa-2">
            <div class="text-right font-italic font-small">Totale: {{ filtered_users.length }}</div>
        </div>
    </div>
    <UserDialog
        max_width="80%"
        ref="user_dialog"
        v-on:updateUsersList="updateUsersList"
    />
    <BaseDialog 
        v-if="dialogUpdatePw.show && dialogUpdatePw.user"
        max_width="600"
        :dialog="dialogUpdatePw.show"
        title="Cambia password"
        v-on:close_dialog="closeChangePwDialog">
            <div class="d-flex flex-column">
                <RowComponent
                    label="nome utente"
                    :value="dialogUpdatePw.user.name" />
                <RowComponent
                    label="email"
                    :value="dialogUpdatePw.user.email" />
                <RowComponent
                    label="password">
                    <v-form v-model="dialogUpdatePw.valid">
                        <v-text-field dense outlined
                            label="nuova password*"
                            v-model="dialogUpdatePw.new_password"
                            :rules = "[rules.mandatory, rules.nameRules]"
                        ></v-text-field>
                    </v-form>
                </RowComponent>
                
            </div>
            <template v-slot:action>
                <v-alert v-if="dialogUpdatePw.errorMessage" type="warning">
                    Aggiornamento fallito: {{dialogUpdatePw.errorMessage}} 
                </v-alert>
                <div class="d-flex align-center justify-center my-4">
                    <v-btn color="primary" :disabled="$store.state.offline || !dialogUpdatePw.valid" @click="updateUserPassword">aggiorna</v-btn>
                    <v-btn text @click="closeChangePwDialog">Annulla</v-btn>
                </div>
            </template>
    </BaseDialog>
    </div>
        
</template>
<script>
    // import {AgGridVue} from "ag-grid-vue";
    // import _ from 'lodash'
    import {f_rules} from "../../utils/commonUtils"
    import UserDialog from "./UserDialog"
    import BaseDialog from '../../components/dialogs/BaseDialog'
    import RowComponent from '../../components/utils/RowComponent'
    import {i_roles_reg} from "../../utils/rolesManagement"
    import { searchDesign } from "../../utils/dbUtility"


    export default {
        components: {UserDialog, BaseDialog, RowComponent},
        name: 'users',
        data() {
            return {
                // columnDefs: null,
                // rowData: null,
                headers: [
                    {text: "Riferimento", value: "name", align: "left", sortable: true},
                    {text: "Recapito telefonico", value: "phone", align: "left", sortable: true},
                    {text: "Username", value: "username", align: "left", sortable: true},
                    {text: "Ruoli", value: "roles", align: "left", sortable: true},
                    {text: "Azioni", value: "actions", aligh: "left", sortable: false},
                ],
                users: [],
                current_modified_idx: -1,
                search: {
                    role: null,
                    org: null
                },
                filtered_users: [],
                userRoles: [],
                rules: f_rules,
                dialogUpdatePw: {
                    show: false,
                    user: null,
                    new_password:'',
                    valid: false,
                    errorMessage: null
                },
                orgs: [],
                orgs_dict: {},
                errorMessage: null,
                loading: false

            }
        },
        async beforeMount() {
            this.loading = true
            this.errorMessage = null
            this.userRoles = i_roles_reg;
            this.roles_dict = _.keyBy(i_roles_reg, 'id');
            this.orgs = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', "organism", false)
            this.orgs_dict = _.keyBy(this.orgs, 'id')
            console.log('ORGS', this.orgs)                
            
            let res = await this.axios.get("/mastercal/users/", { params: { all_data: true } }).catch(error => {
                console.log("error status", error);
                this.errorMessage = "errore di connessione - riprovare. Se il problema persiste contattare l'amministratore"
                this.loading = false
            });
            // this.users = _.map(res.data, 'doc') //_.reduce(res.data, function(result, item) { result.push(item.doc); return result}, [])
            this.users = res.data.filter(user => {
                return user.dismissed != true
            })
            this.loading = false
            this.filtered_users = [...this.users]
            console.log("USERS",this.users)
                
        },
        methods: {
            editUser(user,idx){
                this.current_modified_idx = idx;
                this.$refs.user_dialog.reset(user);
                console.log("DEBUG INDEX", this.current_modified_idx)
            },
            deleteUser(id){
                console.log("TO BE IMPLEMENTED", id);
            },
            custom_filter () {
                console.log(this.search.role, this.search.org)
                this.filtered_users = this.users.filter((doc) => {
                    let role_included = true
                    if (this.search.role) {
                        role_included = doc.roles.includes(this.search.role)
                    }
                    let org_included = true
                    if (this.search.org) {
                        org_included = doc.org_id == this.search.org
                    }
                    return role_included && org_included
                })
            },
            updateUsersList(data, isNew) {
                if (isNew) {
                    this.$set(this.users, this.users.length, data)
                    this.$store.commit("showSnackbar", {text: "Utente aggiunto", color: 'primary'})
                    //this.users.push(data)
                } else {
                    let temp = this.users[this.current_modified_idx]
                    if (temp._id == data._id) {
                        this.$set(this.users, this.current_modified_idx, data)
                        //this.users.splice(this.current_modified_idx,1, data)
                        this.$store.commit("showSnackbar", {text: "Utente aggiornato", color: 'primary'})
                    }
                }
                this.$store.dispatch('setUsers', {axios: this.axios})
                this.custom_filter()
            },
            changePassword(user, idx) {
                this.current_modified_idx = idx;
                this.dialogUpdatePw.user = _.cloneDeep(user)
                this.dialogUpdatePw.new_password = ''
                this.dialogUpdatePw.show = true
                this.dialogUpdatePw.errorMessage = null
            },
            closeChangePwDialog() {
                this.dialogUpdatePw.show = false
                this.dialogUpdatePw.user = null
                this.dialogUpdatePw.new_password = ''
            },
            findUser(user_id){
                for(let user of this.users){
                    if(user._id == user_id){
                        return user
                    }
                }
                return null
            },
            updateUserPassword() {
                let temp = this.findUser(this.dialogUpdatePw.user._id)
                if (temp != null && temp._id == this.dialogUpdatePw.user._id) {
                    this.dialogUpdatePw.user.password = this.dialogUpdatePw.new_password
                    this.axios.put('mastercal/users/'+this.dialogUpdatePw.user._id, {...this.dialogUpdatePw.user}).then(
                        (res) => {
                            console.log("DEBUG, put user", res)
                            this.$set(this.users, this.current_modified_idx, res.data)
                            this.closeChangePwDialog()
                            this.$store.commit("showSnackbar", {text: "Password aggiornata", color: 'primary'})
                    }).catch(error => {
                        console.log("error status", error);
                        this.dialogUpdatePw.errorMessage = "errore di connessione al server - riprovare. Se il problema persiste contattare l'amministratore"
                    });
                } else {
                    console.log("utente non corretto")
                }
            }
        }
    }
</script>